import { Box, styled } from "@mui/material"
import { colors } from "../../theme/colors"

export const LoadingOverlayRoot = styled(Box)<{
  disableOpacity: boolean | undefined
}>(({ disableOpacity }) => ({
  position: "fixed",
  top: "0",
  bottom: "0",
  left: "0",
  right: "0",
  zIndex: 999,
  backgroundColor: colors.white,
  opacity: disableOpacity ? 1 : 0.5,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}))
